// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Step 2: Inventory rollforward step. A thin wrapper over RollforwardReviewStep supplying the
 * inventory waterfall chart and copy; the shared component owns the review, auto-advance, and
 * flourish behavior. Amounts are never netted across currencies.
 */
import {
  CloseRunCurrencyBucket,
  JournalEntryWithReviewState,
} from '@/accounting/api/types';
import { RollforwardReviewStep } from '@/accounting/components/rollforward-review-step';
import { AssetWaterfallChart } from '@/report/components/asset-waterfall-chart';

interface Props {
  entries: JournalEntryWithReviewState[];
  buckets: CloseRunCurrencyBucket[];
  onEntriesChange: (entries: JournalEntryWithReviewState[]) => void;
  onNext: () => void;
  onBack: () => void;
}

export function InventoryRollforwardStep(props: Props) {
  return (
    <RollforwardReviewStep
      entries={props.entries}
      buckets={props.buckets}
      onEntriesChange={props.onEntriesChange}
      onNext={props.onNext}
      onBack={props.onBack}
      idNamespace="inventory-rollforward-section"
      chartTitle="Inventory rollforward"
      chartSubheader="Review inventory balance changes"
      journalSubheader="Review and export journal entries for inventory transactions"
      emptyMessage="No inventory rollforward data for this period"
      continueLabel="Continue to fixed asset rollforward"
      renderChart={(bucket, metricType) => (
        <AssetWaterfallChart
          data={bucket.inventoryRollforward}
          metricType={metricType}
          currencyCode={bucket.currency}
        />
      )}
    />
  );
}
